'use strict';

/* eslint no-undef: "off" */
/**
 * cms index app
 */
define('countryChoose',['util', 'busEvent', 'headerNavbar', 'getCityListApi', 'addressPicker', 'changeCityApi', 'GAReport'], function (Util, busEvent, headerNavbar, getCityListApi, Picker, changeCityApi, GAReport) {
  return {
    template: '\n        <div class="in-mask in-choose-country">\n          <div class="in-side-menu" @click.prevent="stopBubble($event)">\n            <header-navbar :show-menu-btn="true" @backBtnClicked="hideMenuPanel" :custom-back="true">\n              <template slot="title">\n                <img class="logo-image" :src="logo.url">fix/address-bug\n              </template>\n            </header-navbar>\n            <div class="menu-area">\n              <div class="menu-container">\n                <p class="menu-title" v-text="i18n.choose"></p>\n                <div class="menu-content">\n                  <p v-for="country in countries">\n                    <a :href="country.href" :class="{active: country.isCurrent}" @click="onCountryChanged(country.title, $event)">\n                      <span class="in-choose-country-text">\n                        <img :src="country.image" />\n                        <span v-html="country.title"></span>\n                      </span>\n                      <i v-if="country.isCurrent" class="xp-iconfont xp-icon-selected in-choose-country-icon"></i>\n                    </a>\n                  </p>\n                </div>\n              </div>\n              <div class="menu-container" v-if="areaList.length">\n                <p class="menu-title" v-text="i18n.selectCity"></p>\n                <div class="menu-content" @click="showPicker(\'pickerArea\')">\n                  <p>\n                    <a href="#">\n                      <span class="in-choose-country-text">\n                        <span v-html="curCity.name"></span>\n                      </span>\n                      <i class="xmall-icon icon-arrow-down"></i>\n                    </a>\n                  </p>\n                </div>\n\n                <div class="in-address-select">\n                  <Picker @select="handleSelectArea(\'pickerArea\')" :area="areaList" :selected-index="areaIndex" ref="pickerArea" :title="i18n.selectAreaTitle"></Picker>\n                  <Picker @select="handleSelectCity(\'pickerCity\')" :area="cityList" :selected-index="cityIndex" ref="pickerCity" :title="i18n.selectCityTitle"></Picker>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      ',
    data: function data() {
      return {
        stores: window.commonDataJSON.stores,
        logo: window.commonDataJSON.logo,
        baseUrl: window.commonDataJSON.base_url,
        i18n: {
          choose: 'Please select your country or region',
          selectCity: 'Please select your city',
          selectCityTitle: 'Select Your City'
        },
        countries: window.commonDataJSON.xpark_webs || [],
        areaList: [],
        cityList: [],
        areaIndex: ['0'],
        cityIndex: ['0'],
        curCity: {
          name: 'CITY',
          id: ''
        },
        selectedIndex: ['0']
      };
    },

    components: {
      headerNavbar: headerNavbar,
      Picker: Picker
    },
    mounted: function mounted() {
      this.getCityList();
    },

    methods: {
      /**
         * close menu panel
         */
      hideMenuPanel: function hideMenuPanel() {
        $('body').removeClass('in-country-open');
      },
      stopBubble: function stopBubble(e) {
        e.stopPropagation();
      },
      getCityList: function getCityList() {
        var _this = this;

        getCityListApi().then(function (resData) {
          _this.areaList = resData;
          _this.filterCurCity();
        });
      },
      filterCurCity: function filterCurCity() {
        var _this2 = this;

        this.curCity = this.areaList.filter(function (area, index) {
          if (area.is_default) {
            _this2.areaIndex = [String(index)];
          }
          return area.is_default;
        })[0].children.filter(function (city, index) {
          if (city.is_default) {
            _this2.cityIndex = [String(index)];
          }
          return city.is_default;
        })[0];

        this.areaList = this.handleData(this.areaList);
      },
      handleSelectArea: function handleSelectArea() {
        var picker = this.$refs['pickerArea'];
        var selectedStateIndex = picker._data.pickerSelectedIndex[0];
        var cityList = this.areaList[0][selectedStateIndex].children && this.areaList[0][selectedStateIndex].children;
        if (cityList.length) {
          this.cityList = this.handleData(cityList);
          this.showPicker('pickerCity');
        }
      },
      handleSelectCity: function handleSelectCity() {
        var picker = this.$refs['pickerCity'];
        var selectedStateIndex = picker._data.pickerSelectedIndex[0];
        this.changeCity(this.cityList[0][selectedStateIndex]);
      },

      /**
       *  将现有数据转换为picker所需结构
       */
      handleData: function handleData(data) {
        var resultData = data;
        var length = data.length;
        for (var i = 0; i < length; i++) {
          resultData[i].isChecked = data[i].is_default;
          resultData[i].text = data[i].name ? data[i].name : data[i].text;
        }
        return [resultData];
      },

      /**
       *  picker事件
       */
      showPicker: function showPicker(index) {
        var picker = this.$refs[index];
        if (picker) {
          picker.show();
        }
      },
      changeCity: function changeCity(city) {
        var _this3 = this;

        changeCityApi({ cityId: city.id }).then(function (resData) {
          // window.location.reload()
          _this3.cityList[0] = _this3.cityList[0].map(function (item) {
            item.isChecked = 0;
            if (item.id === city.id) {
              item.isChecked = 1;
              _this3.curCity = item;
            }
            return item;
          });
        });

        if (city.name) {
          new GAReport().customerClick({
            eventAction: 'TOP_CHANGE_SHIP_CITY_TO_' + city.name,
            eventCategory: 'CHANGE_SHIP_CITY_#VERSION#'
          });
        }
      },
      onCountryChanged: function onCountryChanged(country, e) {
        new GAReport().customerClick({
          eventAction: 'COUNTRY_CHANGE_TO_' + country,
          eventCategory: 'COUNTRY_CHANGE_#VERSION#'
        });

        e.stopPropagation();
      }
    }
  };
});
